import { subscribe } from 'valtio';
import { derive } from 'valtio/utils';

import {
  currentConnectionStatus,
  currentPendingChanges,
  currentPermissions,
  isBoardReadOnly,
  isBoardReadOnlyDefault,
} from '@canvas/canvas-state';
import { createBoardSyncStateMachineV2 } from '@canvas/connection-state/board-sync-v2';

import { ContentSyncState, syncContentStateChanges } from './syncContentStateChanges';

export function initializeContentSyncMachine() {
  const contentSyncStateMachine: ReturnType<typeof createBoardSyncStateMachineV2> =
    createBoardSyncStateMachineV2();

  const state: ContentSyncState = derive({
    pendingChanges: (get) => get(currentPendingChanges).areChangesPending,
    connectionStatus: (get) => get(currentConnectionStatus).connectionStatus,
    readOnly: (get) => isBoardReadOnly(get(currentPermissions).boardAccess),
    id: (get) => get(currentPermissions).id,
  });

  const prevState = {
    pendingChanges: false,
    readOnly: isBoardReadOnlyDefault,
    id: undefined,
  };

  subscribe(
    state,
    () => {
      syncContentStateChanges({
        contentSyncStateMachine,
        state,
        prevState,
      });
    },
    true
  );
}
